import useReactGASend from "../../../../hooks/useReactGASend";

const InternalLinkButton = ({ label, href }) => {
  const { makeEventTrackFn } = useReactGASend();

  const handleClick = () => {
    makeEventTrackFn({
      category: "event",
      action: `${label}(FAQ)`,
      data_btn_nm: `${label}(FAQ)`,
      data_btn_url: href,
    });
  };
  return (
    <a
      href={href}
      className="flex items-center justify-center gap-6 p-2 font-medium leading-none bg-white border-[1px] min-h-12 w-64 text-brand-button-text-dialog border-brand-button-border-dialog rounded-2xl"
      onClick={handleClick}
    >
      {/* <img src={iconLink} alt="" /> */}
      {label}
    </a>
  );
};

export default InternalLinkButton;
